<template>
  <div>
    <!-- <el-table
      :data="chains"
      style="width: 100%">
      <el-table-column
        prop="chainFullName"
        sortable
        label="公链全称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="chainShortName"
        sortable
        label="公链缩写"
        width="180">
      </el-table-column>
      <el-table-column
        prop="symbol"
        sortable
        label="原生代币">
      </el-table-column>
      <el-table-column
        prop="lastHeight"
        sortable
        label="最新区块高度">
      </el-table-column>
      <el-table-column
        prop="lastBlockTime"
        sortable
        label="最新区块时间">
      </el-table-column>
      <el-table-column
        prop="circulatingSupply"
        sortable
        label="流通数量">
      </el-table-column>
      <el-table-column
        prop="circulatingSupplyProportion"
        sortable
        label="流通占比">
      </el-table-column>
      <el-table-column
        prop="transactions"
        sortable
        label="交笔总数">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        sortable
        label="更新时间">
      </el-table-column>
    </el-table>-->
    <div style="color: white; font-size:24px; display: flex">
      <div class="block">
        <span class="demonstration">时间范围:</span>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        ></el-date-picker>
      </div>
      <el-button type="primary" @click="fold()">折叠/展开</el-button>市值区间:
      <el-input class="input1 input3" type="number" v-model="minsz" placeholder="最低市值"></el-input>~
      <el-input class="input1 input3" type="number" v-model="maxsz" placeholder="最高市值"></el-input>代币数量:
      <el-input
        class="input1"
        type="number"
        style="width: 120px"
        :value="countsz"
        disabled="disabled"
      ></el-input>公链:
      <el-select v-model="chainid" clearable placeholder="请选择">
        <el-option
          v-for="item in chains"
          :key="item.chainShortName"
          :label="item.chainShortName"
          :value="item.id"
        >
          <span style="float: left; color: white; ">{{ item.chainShortName }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.chainFullName }}</span>
        </el-option>
      </el-select>合约地址:
      <el-input class="input1 input3" type="text" v-model="tokenContractAddress"></el-input>
      <el-button type="primary" @click="gettoken(0, true)">查询</el-button>
    </div>
    <el-table :data="tokens" @sort-change="sortChange" style="width: 100%">
      <!-- v-for="(l, index) in ls" :key="index"> 后续使用v-for循环 -->
      <!-- <el-table-column :prop="l.prop" sortable :label="l.label" :width="l.width">
      </el-table-column>-->
      <el-table-column fixed prop="tokenFullName" sortable label="代币全称" width="180"></el-table-column>
      <el-table-column prop="token" sortable label="代币简称" width="100"></el-table-column>
      <el-table-column prop="precision" sortable label="精度" width="80"></el-table-column>
      <el-table-column
        :prop="foldparams.tokenContractAddress"
        sortable
        :label="foldparams['合约地址']"
        :width="foldparams.width"
      ></el-table-column>
      <el-table-column prop="protocolType" sortable label="协议类型" width="100"></el-table-column>
      <el-table-column prop="addressCount" sortable label="地址数" width="100"></el-table-column>
      <el-table-column prop="totalSupply" sortable label="最大供应量" width="120"></el-table-column>
      <el-table-column prop="circulatingSupply" sortable label="流通量" width="100"></el-table-column>
      <el-table-column prop="price" sortable label="价格(USD)" width="160"></el-table-column>
      <el-table-column label="走势" width="100">
        <template slot-scope="scope">
          <div :id="scope.row.id" class="api-chart"></div>
        </template>
      </el-table-column>
      <el-table-column
        :prop="foldparams.website"
        sortable
        :label="foldparams['官方网站']"
        :width="foldparams.width"
      ></el-table-column>
      <el-table-column prop="totalMarketCap" sortable label="总市值" width="100"></el-table-column>
      <el-table-column prop="issueDate" sortable label="发行日期" width="150"></el-table-column>
      <el-table-column prop="updateTime" sortable label="更新时间"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="tokendetail(scope.row)" type="text" size="small">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="color: white; font-size:24px">
      单页条数:
      <el-input class="input1 input2" type="number" v-model="pagelimit" @blur="gettoken()"></el-input>
      <!-- <button @click="gettoken(-1)">上一页</button> -->
      <el-button type="primary" @click="gettoken(-1)">上一页</el-button>第
      <el-input class="input1 input2" type="number" v-model="page" @blur="gettoken()"></el-input>/
      <el-input
        class="input1 input2"
        type="number"
        :value="Math.floor(countsz/pagelimit)+1"
        disabled="disabled"
      ></el-input>页
      <el-button type="primary" @click="gettoken(1)">下一页</el-button>
    </div>
    <!-- 弹框 代币详情 TODO-->
    <el-dialog
      :title="chart['tokenname']"
      :visible.sync="dialogTableVisible"
      @opened="searchData()"
    >
      <div ref="myChart" :style="{ width: '100%', height: '500px' }"></div>
    </el-dialog>
  </div>
</template>

<script>
import { get } from "@/api/index";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      chains: [],
      chains_d: {},
      chainid: "",
      tokens: [],
      page: 1,
      pagelimit: 50,
      foldparams: {
        width: 1,
        tokenContractAddress: "",
        合约地址: "",
        website: "",
        官方网站: ""
      },
      minsz: 0,
      maxsz: 100000000000000,
      countsz: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value2: "",
      tokenContractAddress: "", // for 搜索
      dialogTableVisible: false,
      // 图表数据
      chart: {
        tokenid: 0,
        tokenname: "",
        addressCount: [],
        totalSupply: [],
        circulatingSupply: [],
        price: [],
        totalMarketCap: [],
        updateTime: []
      }
    };
  },
  mounted() {
    this.getchain();
    this.gettoken(0, true);
    // this.drawLines();

    this.foldparams["width"] = 0;
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },

    getchain() {
      // 获取公链数据
      var that = this;
      var url = this.$baseUrl + "/chains/get";
      var param = { token: this.token };
      get(url, param).then(resp => {
        console.log(resp);
        if (resp.code === 200) {
          that.chains = resp.data;
          that.chains.forEach(function(element) {
            that.chains_d[element.id] = element.chainShortName;
          });
          console.log(that.chains_d);
        } else {
          this.$notify.error({
            message: resp.info,
            title: "提示",
            offset: 100
          });
        }
      });
    },
    gettoken(p = 0, p1 = false) {
      // 获取公链数据
      var that = this;

      that.page = parseInt(that.page) + p;
      if (p1) {
        that.page = 1;
      }
      var url = this.$baseUrl + "/tokens/get";
      var param = {
        token: this.token,
        limit: that.pagelimit,
        page: that.page,
        minsz: that.minsz,
        maxsz: that.maxsz,
        chainid: that.chainid,
        tokenContractAddress: that.tokenContractAddress
      };
      if (that.px != null) {
        param["field"] = that.field;
        param["px"] = that.px;
      }
      if (that.value2 != "") {
        param["startdate"] = that.value2[0].format("yyyy-MM-dd hh:mm:ss");
        param["enddate"] = that.value2[1].format("yyyy-MM-dd hh:mm:ss");
      }
      console.log("param:", param);
      console.log(param);
      get(url, param).then(resp => {
        console.log(resp);
        if (resp.code === 200) {
          that.tokens = resp.data;
          that.countsz = resp.count;
          that.$nextTick(() => {
            that.drawLines();
          });
        } else {
          this.$notify.error({
            message: resp.info,
            title: "提示",
            offset: 100
          });
        }
      });
    },
    fold() {
      // 获取公链数据
      if (this.foldparams["width"] == 0) {
        this.foldparams["width"] = 188;
        this.sleep(100).then(() => {
          this.foldparams["tokenContractAddress"] = "tokenContractAddress";
          this.foldparams["合约地址"] = "合约地址";
          this.foldparams["website"] = "website";
          this.foldparams["官方网站"] = "官方网站";
        });
      } else {
        this.foldparams["tokenContractAddress"] = "";
        this.foldparams["合约地址"] = "";
        this.foldparams["website"] = "";
        this.foldparams["官方网站"] = "";
        this.foldparams["width"] = 0;
      }
    },
    sortChange({ prop, order }) {
      console.log(prop, order);
      this.field = prop;
      this.px = order;
      this.gettoken();
    },
    tokendetail(row) {
      console.log(row);
      this.chart["tokenid"] = row.id;
      this.chart["tokenname"] = row.token + "代币详情";
      this.dialogTableVisible = true;
      // this.searchData();
    },
    searchData() {
      var that = this;
      var url = this.$baseUrl + "/tokenshistory/get";
      console.log("that.chart.tokenid:", that.chart.tokenid);
      var param = {
        token: this.token,
        tokenid: that.chart.tokenid
      };
      get(url, param).then(resp => {
        console.log(resp);
        if (resp.code === 200) {
          let data = resp.data;
          this.chart.updateTime = data.map(i => {
            return i.updateTime;
          });
          this.chart.addressCount = data.map(i => {
            return i.addressCount;
          });
          this.chart.totalSupply = data.map(i => {
            return i.totalSupply;
          });
          this.chart.circulatingSupply = data.map(i => {
            return i.circulatingSupply;
          });
          this.chart.price = data.map(i => {
            return i.price;
          });
          this.chart.totalMarketCap = data.map(i => {
            return i.totalMarketCap;
          });
          this.drawLine(); //折线图
        } else {
          this.$notify.error({
            message: resp.info,
            title: "提示",
            offset: 100
          });
        }
      });
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let mc = this.$refs.myChart;
      let myChart = this.$echarts.init(mc);
      // 绘制图表
      myChart.setOption({
        title: {
          text: "单位:USD",
          top: "30",
          left: "32",
          textStyle: {
            fontSize: 16, //字体大小
            color: "#333", //字体颜色
            fontWeight: "500"
          }
        },
        tooltip: {
          //触发类型：坐标轴触发
          trigger: "axis", //触发类型  'item'图形触发：散点图，饼图等无类目轴的图表中使用； 'axis'坐标轴触发；'none'：什么都不触发。
          axisPointer: {
            type: "line", //默认为line，line直线，cross十字准星，shadow阴影
            lineStyle: {
              type: "dashed",
              color: "#808BA9"
            }
          },
          backgroundColor: "#fff", //也可以通过设置rgba调节背景颜色与透明度
          color: "#333",
          borderWidth: "1",
          borderColor: "#D9E1F8",
          textStyle: {
            color: "#333",
            fontSize: "12",
            lineHeight: "17"
          },
          formatter: function(arg) {
            // 自定义提示
            var rut = arg[0].name + "<br>";
            for (let i = 0; i < arg.length; i++) {
              rut =
                rut +
                '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
                arg[i].color +
                ';"></span>' +
                arg[i].seriesName +
                '<span style="margin-left:10px;">' +
                arg[i].data +
                "</span>" +
                "<br>";
            }
            return rut;
          }
        },
        legend: {
          icon: "circle",
          itemHeight: 10, //修改icon图形大小
          textStyle: {
            fontSize: 14,
            color: "#333"
          },
          x: "left", //可设定图例在左、右、居中
          y: "top", //可设定图例在上、下、居中
          padding: [81, 0, 0, 32] //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
        },
        grid: {
          top: "145",
          left: "17",
          right: "17",
          bottom: "41",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.chart.updateTime,
          //使坐标轴刻度与标签对齐
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            // 改变x轴颜色
            lineStyle: {
              // color: "#D9E1F8",
              color: "#666",
              width: "1"
            }
          },
          axisLabel: {
            // 改变x轴字体颜色和大小
            formatter(val) {
              return "{a|" + `${val}` + "}";
            },
            rich: {
              a: {
                height: 40, // 设置字体行高
                color: "#666",
                fontSize: 14
              }
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false //y轴线消失
          },
          axisTick: {
            show: false //y轴坐标点消失
          },
          boundaryGap: [0.1, 0], //有负数设置这个
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#D9E1F8"
            }
          },
          axisLabel: {
            textStyle: {
              fontSize: 14,
              color: "#92A5E3"
            }
          }
        },
        series: [
          {
            name: "持币地址数",
            type: "line", //bar:柱状 line:折线图
            data: this.chart.addressCount,
            color: "#00C5AB",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8 //折线点的大小
          },
          {
            name: "最大供应量",
            type: "line",
            data: this.chart.totalSupply,
            color: "#3F53FF",
            symbolSize: 8 //折线点的大小
          },
          {
            name: "流通量",
            type: "line",
            data: this.chart.circulatingSupply,
            color: "#8DF3E8",
            symbolSize: 8 //折线点的大小
          },
          {
            name: "价格",
            type: "line",
            data: this.chart.price,
            color: "#FF33FF",
            symbolSize: 8 //折线点的大小
          },
          {
            name: "总市值",
            type: "line",
            data: this.chart.totalMarketCap,
            color: "#000000",
            symbolSize: 8 //折线点的大小
          }
        ]
      });
    },
    drawLines() {
      var that = this;
      // 列表页走势线
      this.tokens.forEach(function(e) {
        console.log("e:", e);
        var node = document.getElementById(e.id);
        var myChart = that.$echarts.init(node);
        var y_data = e.hps;
        var x_data = e.hts;
        var option = {
          // tooltip: {
          //     show: true,
          //     trigger: 'axis',
          //     formatter: function (param) {
          //         var htmlStr = param[0].axisValue + '<br>';
          //         var currency_value = y_data[param[0].dataIndex];
          //         htmlStr += param[0].marker + 'USDT' + ': ' + currency_value.toFixed(2);
          //         return htmlStr;
          //     },
          //     position: [0, 30]
          // },
          calculable: true,
          grid: {
            left: "2%",
            right: "2%",
            bottom: "-30%",
            top: "2%",
            containLabel: true
          },
          dataZoom: [
            {
              type: "inside",
              start: 30,
              end: 100
            }
          ],
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: x_data,
              show: false,
              axisTick: {
                show: false
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              show: false,
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              }
            }
          ],
          series: [
            {
              name: name,
              type: "line",
              symbol: "none",
              smooth: true,
              showSymbol: false,
              data: y_data,
              lineStyle: {
                color: "red",
                width: 1
              }
            }
          ]
        };

        myChart.setOption(option);
      });
    },
    // 以下双均线弹窗
    tokendetail2(row) {
      console.log(row);
      this.chart["tokenid"] = row.id;
      this.chart["tokenname"] = row.token + "代币详情";
      this.dialogTableVisible = true;
      // this.searchData();
    },
    searchData2() {
      var that = this;
      var url = this.$baseUrl + "/tokenshistory/get";
      console.log("that.chart.tokenid:", that.chart.tokenid);
      var param = {
        token: this.token,
        tokenid: that.chart.tokenid
      };
      get(url, param).then(resp => {
        console.log(resp);
        if (resp.code === 200) {
          let data = resp.data;
          this.chart.updateTime = data.map(i => {
            return i.updateTime;
          });
          this.chart.addressCount = data.map(i => {
            return i.addressCount;
          });
          this.chart.totalSupply = data.map(i => {
            return i.totalSupply;
          });
          this.chart.circulatingSupply = data.map(i => {
            return i.circulatingSupply;
          });
          this.chart.price = data.map(i => {
            return i.price;
          });
          this.chart.totalMarketCap = data.map(i => {
            return i.totalMarketCap;
          });
          this.drawLine(); //折线图
        } else {
          this.$notify.error({
            message: resp.info,
            title: "提示",
            offset: 100
          });
        }
      });
    },
    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      let mc = this.$refs.myChart;
      let myChart = this.$echarts.init(mc);
      // 绘制图表
      myChart.setOption({
        title: {
          text: "单位:USD",
          top: "30",
          left: "32",
          textStyle: {
            fontSize: 16, //字体大小
            color: "#333", //字体颜色
            fontWeight: "500"
          }
        },
        tooltip: {
          //触发类型：坐标轴触发
          trigger: "axis", //触发类型  'item'图形触发：散点图，饼图等无类目轴的图表中使用； 'axis'坐标轴触发；'none'：什么都不触发。
          axisPointer: {
            type: "line", //默认为line，line直线，cross十字准星，shadow阴影
            lineStyle: {
              type: "dashed",
              color: "#808BA9"
            }
          },
          backgroundColor: "#fff", //也可以通过设置rgba调节背景颜色与透明度
          color: "#333",
          borderWidth: "1",
          borderColor: "#D9E1F8",
          textStyle: {
            color: "#333",
            fontSize: "12",
            lineHeight: "17"
          },
          formatter: function(arg) {
            // 自定义提示
            var rut = arg[0].name + "<br>";
            for (let i = 0; i < arg.length; i++) {
              rut =
                rut +
                '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
                arg[i].color +
                ';"></span>' +
                arg[i].seriesName +
                '<span style="margin-left:10px;">' +
                arg[i].data +
                "</span>" +
                "<br>";
            }
            return rut;
          }
        },
        legend: {
          icon: "circle",
          itemHeight: 10, //修改icon图形大小
          textStyle: {
            fontSize: 14,
            color: "#333"
          },
          x: "left", //可设定图例在左、右、居中
          y: "top", //可设定图例在上、下、居中
          padding: [81, 0, 0, 32] //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
        },
        grid: {
          top: "145",
          left: "17",
          right: "17",
          bottom: "41",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.chart.updateTime,
          //使坐标轴刻度与标签对齐
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            // 改变x轴颜色
            lineStyle: {
              // color: "#D9E1F8",
              color: "#666",
              width: "1"
            }
          },
          axisLabel: {
            // 改变x轴字体颜色和大小
            formatter(val) {
              return "{a|" + `${val}` + "}";
            },
            rich: {
              a: {
                height: 40, // 设置字体行高
                color: "#666",
                fontSize: 14
              }
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false //y轴线消失
          },
          axisTick: {
            show: false //y轴坐标点消失
          },
          boundaryGap: [0.1, 0], //有负数设置这个
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#D9E1F8"
            }
          },
          axisLabel: {
            textStyle: {
              fontSize: 14,
              color: "#92A5E3"
            }
          }
        },
        series: [
          {
            name: "持币地址数",
            type: "line", //bar:柱状 line:折线图
            data: this.chart.addressCount,
            color: "#00C5AB",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8 //折线点的大小
          },
          {
            name: "最大供应量",
            type: "line",
            data: this.chart.totalSupply,
            color: "#3F53FF",
            symbolSize: 8 //折线点的大小
          },
          {
            name: "流通量",
            type: "line",
            data: this.chart.circulatingSupply,
            color: "#8DF3E8",
            symbolSize: 8 //折线点的大小
          },
          {
            name: "价格",
            type: "line",
            data: this.chart.price,
            color: "#FF33FF",
            symbolSize: 8 //折线点的大小
          },
          {
            name: "总市值",
            type: "line",
            data: this.chart.totalMarketCap,
            color: "#000000",
            symbolSize: 8 //折线点的大小
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss">
.input1 {
  height: 32px;
  font-size: 20px;
}
.input2 {
  width: 100px;
}
.input3 {
  width: 200px;
}
.el-dialog__title {
  color: white;
  line-height: 45px;
  font-size: 28px;
}
.el-dialog__header {
  height: 50px;
}
.api-chart {
  height: 30px;
  width: 80px;
  margin: 0 auto;
}
</style>
